import React, { useState } from 'react'

function counterColor(current, max) {
  const ratio = current / max
  if (ratio >= 1) return '#e53e3e'
  if (ratio >= 0.9) return '#e88a3a'
  if (ratio >= 0.75) return '#d4a017'
  return 'var(--text-secondary)'
}

export function SingleInput({ value, onChange, maxChars, placeholder, centered, fontSize, multiline, disabled }) {
  const [focused, setFocused] = useState(false)
  // Support both { word } and { text } shapes — derive key from whichever exists
  const key = value && 'word' in value ? 'word' : 'text'
  const current = value?.[key] ?? ''

  const showCounter = multiline || focused
  const ratio = current.length / maxChars
  const counterStyle = {
    ...styles.counter,
    textAlign: centered ? 'center' : 'right',
    color: counterColor(current.length, maxChars),
    opacity: ratio >= 0.75 ? 0.9 : 0.5,
  }

  const sharedProps = {
    style: {
      ...styles.input,
      fontSize,
      textAlign: centered ? 'center' : 'left',
      fontWeight: centered ? 500 : 400,
      ...(multiline ? { resize: 'none', flex: 1, overflowY: 'auto' } : {}),
    },
    value: current,
    placeholder: disabled ? '' : placeholder,
    maxLength: maxChars,
    disabled,
    onChange: (e) => !disabled && onChange({ [key]: e.target.value }),
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
    'aria-label': 'Input',
  }

  return (
    <div style={{ ...styles.wrap, textAlign: centered ? 'center' : 'left', ...(multiline ? { flex: 1 } : {}) }}>
      {multiline ? <textarea {...sharedProps} rows={3} /> : <input {...sharedProps} />}
      {showCounter && (
        <div style={counterStyle}>
          {current.length}/{maxChars}
        </div>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '16px 14px 12px', display: 'flex', flexDirection: 'column', gap: '4px' },
  input: {
    width: '100%', border: 'none', outline: 'none', background: 'transparent',
    color: 'var(--text-primary)', lineHeight: '1.5', fontFamily: 'inherit',
  },
  counter: { fontSize: '10px', color: 'var(--text-secondary)', opacity: 0.5 },
}
